import { M65VividWorksFragment } from '@lib/umbraco/generated/types.generated'
import { FC } from 'react'

type M65VividWorksProps = M65VividWorksFragment

const M65VividWorks: FC<M65VividWorksProps> = ({ vwProductId }) => {
  const siteId = '1e259f08-19b0-4ef9-bfd4-b9dbb4ae34a0'

  return (
    <div
      className="vw3d container"
      style={{ width: '100%' }}
      data-vw-site={siteId}
      data-vw-product={vwProductId}
    ></div>
  )
}

export default M65VividWorks
